import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = {
  href: "javascript:void(0);",
  class: "text-dark text-hover-primary"
}
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "menu-item px-3" }
const _hoisted_9 = { class: "menu-item px-3" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "text-lg-right mb-3" }
const _hoisted_12 = {
  key: 0,
  class: "fa fa-save",
  title: "Save"
}
const _hoisted_13 = {
  key: 0,
  class: "fa fa-window-close",
  title: "Cancel"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Overview ")
], -1)
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = {
  key: 0,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "card mt-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Content Mapping ")
], -1)
const _hoisted_25 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageStatus = _resolveComponent("PageStatus")!
  const _component_QuickAction = _resolveComponent("QuickAction")!
  const _component_FullFroala = _resolveComponent("FullFroala")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Row = _resolveComponent("Row")!
  const _component_Section = _resolveComponent("Section")!
  const _component_File = _resolveComponent("File")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.selectedDoc.name), 1),
            _createVNode(_component_PageStatus, {
              status: _ctx.pageEntity.data.status
            }, null, 8, ["status"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_QuickAction, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  (!_ctx.state.editable)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0);",
                        class: "menu-link px-3",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit(_ctx.pageEntity.data)))
                      }, "Edit"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.pageEntity.data.status === 'DRAFT')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0);",
                        class: "menu-link px-3",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateStatus(_ctx.pageEntity.data.id, 'PUBLISHED')))
                      }, "Publish"))
                    : _createCommentVNode("", true),
                  (_ctx.pageEntity.data.status === 'PUBLISHED')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:void(0);",
                        class: "menu-link px-3",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateStatus(_ctx.pageEntity.data.id, 'DRAFT')))
                      }, "UnPublish"))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: "menu-link px-3 text-danger",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDeleteEntity(_ctx.pageEntity.data)))
                  }, "Delete")
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.state.editable)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: _normalizeClass(["btn btn-sm btn-icon btn-light-primary mr-2", {'spinner spinner-white spinner-right':_ctx.state.submitted}]),
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
                }, [
                  (!_ctx.state.submitted)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.state.editable)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: _normalizeClass(["btn btn-sm btn-icon btn-light-danger mr-2 m-lg-3", {'spinner spinner-white spinner-right':_ctx.state.submitted}]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.editable= false))
                }, [
                  (!_ctx.state.submitted)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", {
            style: {"width":"100%"},
            innerHTML: _ctx.selectedDoc.body,
            id: "editable-show"
          }, null, 8, _hoisted_14), [
            [_vShow, !_ctx.state.editable]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.page.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.page.name]
              ])
            ])
          ], 512), [
            [_vShow, _ctx.state.editable]
          ]),
          _withDirectives(_createVNode(_component_FullFroala, {
            modelValue: _ctx.state.page.body,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.page.body) = $event))
          }, null, 8, ["modelValue"]), [
            [_vShow, _ctx.state.editable]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Row, { row: [{name:'Created By', slot:true, key: 'createdBy'}] }, {
            createdBy: _withCtx(() => [
              (_ctx.pageEntity.data?.createdBy)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_Avatar, {
                      avatar: _ctx.pageEntity.data?.createdBy?.avatar,
                      "user-id": _ctx.pageEntity.data?.createdBy?.id?.toString()
                    }, null, 8, ["avatar", "user-id"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.pageEntity.data?.createdBy?.fullName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Row, {
            row: [{name:'Created', value :_ctx.pageEntity.data.dateCreated, type:'DATE' }]
          }, null, 8, ["row"]),
          (_ctx.pageEntity.data.status ==='PUBLISHED')
            ? (_openBlock(), _createBlock(_component_Row, {
                key: 0,
                row: [{name:'Publish Date', value :_ctx.pageEntity.data.publishedDate, type:'DATE' }]
              }, null, 8, ["row"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Row, {
            row: [{name:'Key', value :_ctx.pageEntity.data.key }]
          }, null, 8, ["row"])
        ])
      ]),
      _createVNode(_component_Section),
      _createVNode(_component_File)
    ])
  ]))
}